import * as React from 'react';

import {Button} from '../button/button';
// @ts-expect-error - imported from .js/.jsx file
import {ExternalLinkIcon} from '../icon/svg/external-link-icon';
import {GlossaryIcon} from '../icon/svg/glossary-icon';
import {Link} from '../link/link';
import {Body} from '../typography/body';

import {getLearnMoreLinkHref} from './add-ons/helpers';
import type {Product} from './types';

type Props = {
    product: Product;
    onOpenModal: () => void;
    size?: 'small' | 'normal';
};

export function LearnMore(props: Props) {
    const {size = 'normal'} = props;

    const learnMoreLinkHref = getLearnMoreLinkHref(props.product);
    const iconSize = size === 'small' ? 11 : 13;

    return (
        <>
            {props.product === 'MARKETING' ? (
                <Button
                    variant='text-primary'
                    onClick={props.onOpenModal}
                    size='big'
                    noPadding={true}
                >
                    <div className='flex gap-6 align-center'>
                        <GlossaryIcon size={iconSize} alignCenter={true} wrapWithDiv={false} />
                        <Body size={size} color='blue'>
                            Learn more
                        </Body>
                    </div>
                </Button>
            ) : (
                <Link variant='primary' newTab={true} href={learnMoreLinkHref}>
                    <div className='flex gap-6 align-center'>
                        <ExternalLinkIcon size={iconSize} alignCenter={true} wrapWithDiv={false} />
                        <Body size={size} color='blue'>
                            Learn more
                        </Body>
                    </div>
                </Link>
            )}
        </>
    );
}
